export default "__VITE_ASSET__CL$oqe$y__"